<template>
    <div class="docs-list" id="section-11" style="display: none">
        <div>
            <h1>Tech Specifications</h1>
            <section class="yunzi first" style="display: block;">
                <h3>Tech Specifications of Yunzi</h3>
                <table>
                    <thead></thead>
                    <tbody>
                    <tr>
                        <td>Chip</td>
                        <td>Nordic</td>
                    </tr>
                    <tr>
                        <td>Dimensions</td>
                        <td>Diameter 50mm, Thickness 19mm</td>
                    </tr>
                    <tr>
                        <td>Weight</td>
                        <td>39g</td>
                    </tr>
                    <tr>
                        <td>Material</td>
                        <td>Polished anodized aluminum alloy ring,White ABS+ transparent PC shell,Matt black ENIG PCB</td>
                    </tr>
                    <tr>
                        <td>Resistances</td>
                        <td>Water resistance/dust-proof/anti-vibration</td>
                    </tr>
                    <tr>
                        <td>Protocol standard</td>
                        <td>BLE 4.0 Through the iBeacon certification</td>
                    </tr>
                    <tr>
                        <td>System Requirements</td>
                        <td>iOS7.0 or above/ Android 4.3 or above</td>
                    </tr>
                    <tr>
                        <td>Upgrade</td>
                        <td>Support for Firmware Over-The Air upgrade</td>
                    </tr>
                    <tr>
                        <td>Security</td>
                        <td>Support Password for Connection</td>
                    </tr>
                    <tr>
                        <td>Sensors</td>
                        <td>Temperature/Light/Accelerometer</td>
                    </tr>
                    <tr>
                        <td>LED</td>
                        <td>3 LEDs</td>
                    </tr>
                    <tr>
                        <td>Radius Power</td>
                        <td>-30dBm to +4dBm; applicable for signal coverage optimization</td>
                    </tr>
                    <tr>
                        <td>Transmission Range</td>
                        <td>Up to 80m</td>
                    </tr>
                    <tr>
                        <td>Broadcast Frequency    (Broadcasting time interval)</td>
                        <td>Adjustable (100~1285ms)</td>
                    </tr>
                    <tr>
                        <td>Power Consumption per Broadcast</td>
                        <td>7.58 * 10<sup>-6</sup>mAh (-8dBm transmitting power)</td>
                    </tr>
                    <tr>
                        <td>Sleep Mode Power Consumption</td>
                        <td>15uW</td>
                    </tr>
                    <tr>
                        <td>Sleep Mode Current</td>
                        <td>5uA</td>
                    </tr>
                    <tr>
                        <td>Supply Voltage</td>
                        <td>3.0V</td>
                    </tr>
                    <tr>
                        <td>Battery</td>
                        <td>Panasonic CR2477 Battery，≥1000mAh</td>
                    </tr>
                    <tr>
                        <td>Operational Mode</td>
                        <td>Send at specific intervals; equipped with intelligent adaptor; expected battery life span1.5~2.5yr</td>
                    </tr>
                    </tbody>
                </table>
            </section>
        </div>
    </div>
</template>

<script>
    export default {
        name: "hw-params"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/docs/hwParams.vue